var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7273 16.0909L17.7273 8.19941C17.7273 7.13533 16.8647 6.27272 15.8006 6.27272L7.90909 6.27273V3.81818C7.90909 3.36631 7.54278 3 7.09091 3C6.63904 3 6.27273 3.36631 6.27273 3.81818V6.27273L3.81818 6.27273C3.36631 6.27273 3 6.63904 3 7.09091C3 7.54278 3.36631 7.90909 3.81818 7.90909L6.27273 7.90909L6.27273 15.8006C6.27273 16.8647 7.13533 17.7273 8.19941 17.7273H16.0909L16.0909 20.1818C16.0909 20.6337 16.4572 21 16.9091 21C17.361 21 17.7273 20.6337 17.7273 20.1818V17.7273H20.1818C20.6337 17.7273 21 17.361 21 16.9091C21 16.4572 20.6337 16.0909 20.1818 16.0909H17.7273ZM16.0909 16.0909L8.19941 16.0909C8.03907 16.0909 7.90909 15.9609 7.90909 15.8006L7.90909 7.90909L15.8006 7.90909C15.9609 7.90909 16.0909 8.03907 16.0909 8.19941L16.0909 16.0909Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.5762f2ac.svg";
export { ForwardRef as ReactComponent };